module.exports = __webpack_public_path__ + "img/logo.3b4ffdf3.png";